export default function cdnUrl(asset, options = {}) {
  const src =
    `https://${process.env.REACT_APP_IMGPROXY_DOMAIN}/plain/rs:fill:320:240/` +
    btoa("s3://" + asset);

  return src;
}
